import React, { useEffect } from 'react';
import { LoginForm } from '../../../shared';
import { RouteComponentProps } from 'react-router-dom';
import {
  useSessionStoreLoading,
  useSessionFacade,
  useSessionStoreError,
} from '../../store/hooks';
import { notification } from 'antd';

const block = 'login-page';

const Login: React.FC<RouteComponentProps> = ({ history }) => {
  const isLoading = useSessionStoreLoading();
  const facade = useSessionFacade();
  const error = useSessionStoreError();

  useEffect(() => {
    if (error) {
      notification.error({
        message: 'Login failed',
        description: error.message,
        onClose: facade.clearError,
      });
    }
  }, [facade, error]);

  const handleSubmit = (user: string, password: string) => {
    facade.login(user, password);
  };

  const handleResetPassword = () => {
    history.push('/auth/reset_password');
  };

  return (
    <div className={block}>
      <h3 style={{ marginBottom: '20px' }}>Sign in</h3>

      <LoginForm
        isLoading={isLoading}
        onSubmit={handleSubmit}
        onResetPassword={handleResetPassword}
      />
    </div>
  );
};

export default Login;
